import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { FunctionalLocation, CostCenter, PlannerGroup } from "@/classes";
import { onMounted, ref, watch, computed } from "vue";
import { setupApiQueue } from "../base/api-queue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FLOCSearch',
  props: /*#__PURE__*/_mergeModels({
    flocs: {},
    costCenters: {},
    plannerGroups: {},
    multiple: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const model = _useModel<FunctionalLocation | FunctionalLocation[] | null>(__props, "modelValue");
const search = ref("");
const searchedFlocs = ref<FunctionalLocation[]>([]);

const props = __props;

const { queueApiAction, loading } = setupApiQueue();

const selectedSome = computed(() => {
  if (
    props.multiple &&
    Array.isArray(model.value) &&
    searchedFlocs.value.length > 0
  ) {
    const flocs = model.value;
    return searchedFlocs.value.some(
      (floc) => !!flocs.find((f) => f.id === floc.id)
    );
  }
  return false;
});

const selectedAll = computed(() => {
  if (
    props.multiple &&
    Array.isArray(model.value) &&
    searchedFlocs.value.length > 0
  ) {
    const flocs = model.value;
    return searchedFlocs.value.every(
      (floc) => !!flocs.find((f) => f.id === floc.id)
    );
  }
  return false;
});

const toggleSelectAll = () => {
  if (selectedAll.value) {
    model.value = [];
  } else {
    model.value = searchedFlocs.value.slice();
  }
};

const debounce = (func: () => void, delay: number) => {
  let timeout: number | null = null;
  return () => {
    if (timeout !== null) clearTimeout(timeout);
    timeout = setTimeout(() => func(), delay);
  };
};

const searchAPI = () => {
  queueApiAction(async () => {
    searchedFlocs.value = FunctionalLocation.fromAxiosList<FunctionalLocation>(
      await FunctionalLocation.$axios.$post<FunctionalLocation[]>(
        "functional-location/search",
        {
          search: search.value,
          floc_ids: (props.flocs || []).map((f) => f.id),
          cost_center_ids: (props.costCenters || []).map((c) => c.id),
          planner_group_ids: (props.plannerGroups || []).map((p) => p.id),
        }
      )
    );
  });
};

const searchAPIDebounced = debounce(searchAPI, 350);

watch(search, searchAPIDebounced);

watch(
  () => props.flocs,
  () => searchAPIDebounced()
);

watch(
  () => props.costCenters,
  () => {
    searchAPIDebounced();
  }
);

watch(
  () => props.plannerGroups,
  () => {
    searchAPIDebounced();
  }
);

onMounted(() => {
  searchAPI();
});

return (_ctx: any,_cache: any) => {
  const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_openBlock(), _createBlock(_component_v_autocomplete, _mergeProps({ class: "floc-search" }, _ctx.$attrs, {
    modelValue: model.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
    search: search.value,
    "onUpdate:search": _cache[1] || (_cache[1] = ($event: any) => ((search).value = $event)),
    items: searchedFlocs.value,
    loading: !!_unref(loading),
    multiple: _ctx.multiple,
    "item-value": "id",
    "item-title": "functional_location",
    "return-object": ""
  }), _createSlots({ _: 2 }, [
    (_ctx.multiple)
      ? {
          name: "prepend-item",
          fn: _withCtx(() => [
            _createVNode(_component_v_list_item, {
              title: "Select All",
              onClick: toggleSelectAll
            }, {
              prepend: _withCtx(() => [
                _createVNode(_component_v_checkbox_btn, {
                  indeterminate: selectedSome.value && !selectedAll.value,
                  "model-value": selectedAll.value
                }, null, 8, ["indeterminate", "model-value"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider)
          ]),
          key: "0"
        }
      : undefined,
    (searchedFlocs.value.length > 100)
      ? {
          name: "append-item",
          fn: _withCtx(() => [
            _createVNode(_component_v_list_item, null, {
              default: _withCtx(() => [
                _createTextVNode(" Keep Searching To Load More...")
              ]),
              _: 1
            })
          ]),
          key: "1"
        }
      : undefined
  ]), 1040, ["modelValue", "search", "items", "loading", "multiple"]))
}
}

})